import request from '@/api/request'

const createSubuser = async (data) => {
  try {
    const response = await request({
      url: '/users/sub_users',
      method: 'post',
      data
    })

    return { response }
  } catch (error) {
    return { error }
  }
}

const getSubusers = (data) => {
  return request({
    url: '/users/sub_users',
    method: 'get'
  })
}

const updateSubuser = async (id, data) => {
  try {
    const response = await request({
      url: `/users/sub_users/${id}`,
      method: 'patch',
      data
    })

    return { response }
  } catch (error) {
    return { error }
  }
}

export default {
  createSubuser,
  getSubusers,
  updateSubuser
}
